import React, { useMemo } from "react";
import SubscriptionIcon from "../../../assets/images/subscription.svg";
import styles from "./LineItemBadge.module.scss";

const badgeSettings = {
  onetime: {
    text: "One Time Purchase",
    backgroundColour: "dark",
    textColour: "white",
  },
  subscription: {
    text: "Subscription",
    backgroundColour: "pink",
    textColour: "dark",
  },
  discount: {
    text: "Free with code",
    backgroundColour: "palegreen",
    textColour: "dark",
  },
  gwp: {
    text: "Free Gift",
    backgroundColour: "palegreen",
    textColour: "dark",
  },
  matchatin: {
    text: "Free matcha tin",
    backgroundColour: "palegreen",
    textColour: "dark",
  },
};

const LineItemBadge = ({ type }) => {
  const settings = useMemo(() => badgeSettings[type], [type]);

  return (
    <div
      className={`d-inline-block gkit-bg-${settings.backgroundColour} gkit-p-13 gkit-bold text-${settings.textColour} mb-0 ${styles.lineItemBadge}`}
    >
      <span className={styles.centreAlign}>
        {type === "subscription" && (
          <img src={SubscriptionIcon} height="20" alt="" className="me-2" />
        )}

        <span>{settings.text}</span>
      </span>
    </div>
  );
};

export default LineItemBadge;
